module.exports = __webpack_public_path__ + "static/img/logo.6e57d91b.png";